export default __webpack_public_path__ + "media/images/mailer-new/heading/email-518e8065193a3f4c196f5bec6a3af9f2.png";